export class EcommStore {
    private uriEncodeParams = (params: Record<string, string> = {}) => {
        return Object.keys(params)
            .map((key) => [key, params[key]].map(encodeURIComponent).join('='))
            .join('&');
    };

    public changeLocation(
        pathName: string,
        queryParams: Record<string, string> = {},
        enforceOrigin: boolean = false
    ) {
        let encodedParams = this.uriEncodeParams(queryParams);
        encodedParams = encodedParams && `?${encodedParams}`;
        const pathWithParams = `${pathName}${encodedParams}`;

        if (!enforceOrigin && (pathName.indexOf('http') === 0 || pathName.indexOf('www') === 0)) {
            window.location.assign(pathWithParams);

            return;
        }
        const url = `${location.origin}${pathWithParams}`;
        window.location.assign(url);
    }
}
